export default __webpack_public_path__ + "static/media/arrowRight.d27ed600.svg";